<template>
  <v-app class="rounded">
    <v-container fluid>
      <v-card elevation="2" outlined>
        <v-card-title>
          <!--                                    v-if="$can('transaction_create')"-->
          <v-btn
            @click="
              (showCreateModal = !showCreateModal),
                (update = false),
                getCategoryPatents()
            "
            class="btn-add-with-text"
            v-status="'message_category_create'"
          >
            <v-icon>mdi-plus</v-icon>
            افزودن دسته بندی
          </v-btn>
          <!--          <v-spacer/>-->
          <!--          {{ $t($route.meta.title) }}-->
          <!--          <v-spacer/>-->
          <!--          <v-btn :loading="loading" @click="reloadTable(tableProps)" class="btn-update">-->
          <!--            <v-icon>mdi-refresh</v-icon>-->
          <!--            به روزرسانی-->
          <!--          </v-btn>-->
        </v-card-title>
        <v-divider />
        <div class="row">
          <div class="col-md-12 p-5">
            <data-table
              :data="data"
              orderDir="desc"
              :columns="columns"
              :debounce-delay="5000"
              :translate="translates"
              :per-page="perPages"
              @on-table-props-changed="reloadTable"
            >
            </data-table>
          </div>
        </div>
      </v-card>
    </v-container>
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="showCreateModal"
      persistent
      max-width="800"
    >
      <template v-slot:default="showCreateModal">
        <v-card>
          <v-toolbar color="#b54405" class="font-weight-bold" dark>
            <v-icon class="pl-1">mdi-menu-open</v-icon>
            <span v-if="!update">ثبت دسته بندی جدید</span>
            <span v-else>بروزرسانی دسته بندی</span>
            <v-spacer></v-spacer>
            <v-btn
              small
              icon
              rounded
              @click="cancelCreate"
              class="ml-1 text-hover-danger text-white"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-row class="mt-5">
              <v-flex class="p-2" xs12 sm12 md4 xl4 lg4>
                <v-text-field
                  outlined
                  label="عنوان"
                  v-model="category.title"
                  dense
                  :error-messages="errors.title"
                ></v-text-field>
              </v-flex>
              <v-flex class="p-2" xs12 sm12 md4 xl4 lg4>
                <v-select
                  :items="services.data"
                  item-text="nameLand"
                  label="انتخاب سرویس"
                  item-value="id"
                  outlined
                  dense
                  clearable
                  v-model="category.service_id"
                  :error-messages="errors.service_id"
                ></v-select>
              </v-flex>
              <v-flex class="p-2" xs12 sm12 md4 xl4 lg4>
                <v-autocomplete
                  :items="parents"
                  item-text="title"
                  label="انتخاب والد"
                  item-value="id"
                  :loading="parentLoading"
                  outlined
                  dense
                  clearable
                  :search-input.sync="searchParents"
                  v-model="category.parent_id"
                  :error-messages="errors.parent_id"
                ></v-autocomplete>
              </v-flex>
            </v-row>
            <v-row>
              <v-container fluid>
                <v-textarea
                  v-model="category.description"
                  :error-messages="errors.description"
                  label="توضیخات"
                  counter
                  outlined
                ></v-textarea>
              </v-container>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn class="btn-cancel" @click="cancelCreate">
              <v-icon>mdi-close-circle</v-icon>
              بستن
            </v-btn>
            <v-btn v-if="update" class="btn-update" @click="updated">
              <v-icon>mdi-update</v-icon>
              بروزرسانی
            </v-btn>
            <v-btn v-else class="submit-btn" @click="store">
              <span class="fa fa-bookmark icon-md ml-1"></span>
              ذخیره
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-app>
</template>

<script>
import Button from "@/view/pages/Button";

export default {
  name: "Index",
  data() {
    return {
      id: null,
      searchParents: null,
      loading: false,
      parentLoading: false,
      update: false,
      parents: [],
      category: {
        title: null,
        service_id: null,
        parent_id: null,
        description: null,
      },
      services: [],
      showCreateModal: false,
      category_id: null,
      data: {},
      errors: [],
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      columns: [
        // {
        //   label: `<input type="checkbox" id="select_all" onclick="window.Vue.$emit('selectAllListCheckBox', this)"/>`,
        //   component: CheckboxFild,
        //   event: 'change',
        //   handler: this.change,
        // },
        {
          label: "ردیف",
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
        },
        {
          label: "شناسه",
          name: "id",
          orderable: true,
        },
        {
          label: "عنوان",
          name: "title",
          orderable: true,
        },
        {
          label: "سرویس",
          name: "service_id",
          orderable: true,
          transform: ({ data }) => {
            if (data.service_id === null) return "ندارد!";
            return this.$options.filters.serviceType(data.service.nameLand);
          },
        },
        {
          label: "زیر مجموعه:",
          name: "parent_id",
          orderable: true,
          transform: ({ data }) => {
            if (data.parent_id !== null) return data.parent.title;
            return "ندارد!";
          },
        },
        {
          label: "وضعیت نمایش",
          name: "deleted_at",
          orderable: true,
          transform: ({ data }) => {
            if (data.deleted_at !== null) return "غیرفعال!";
            return "فعال!";
          },
        },

        {
          label: "توضیحات",
          name: "description",
          transform: (val) => {
            return `<p class="text-truncate " style="width: 12rem">${val.data.description}</p>`;
          },
        },
        {
          label: "عملیات",
          name: "actions",
          handler: this.actions,
          component: Button,
          event: "action",
          meta: {
            permission_prefix: "message_category_",
            buttons: [
              {
                label: "ویرایش",
                name: "edit",
                icon: "pencil-alt",
                class: "btn-edit",
              },
              {
                name: "delete",
                label: "حذف",
                icon: "trash",
                class: "btn-delete",
              },
            ],
          },
        },
      ],
      url: "message/category",
    };
  },
  methods: {
    getMessageCategories(url = this.url, query = this.tableProps) {
      if (query.search === "") this.$modal.showLoading();
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.data = data;
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
        });
    },
    getCategoryPatents(url = this.url + "-parent", query) {
      this.parentLoading = true;
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.parentLoading = false;
          this.parents = data.data;
          console.log(this.parents);
        })
        .catch(({ response }) => {
          this.parentLoading = false;
        });
    },
    store() {
      this.$modal.showLoading();
      this.requestApiPost(this.url, this.category)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.getMessageCategories();
          this.cancelCreate();
          this.$toast.success("دسته بندی ایجاد شد");
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
          this.errors = response.data.errors;
        });
    },
    updated() {
      this.$modal.showLoading();
      this.requestApiPut(`${this.url}/${this.category_id}`, this.category)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.cancelCreate();
          this.getMessageCategories();
          this.$toast.success("دسته بندی با موفقیت بروزرسانی شد.");
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
          this.errors = response.data.errors;
        });
    },
    cancelCreate() {
      this.showCreateModal = false;
      this.update = false;
      this.errors = [];
      this.category = {
        title: null,
        description: null,
        service_id: null,
        parent_id: null,
      };
    },

    reloadTable(tableProps) {
      this.getMessageCategories(this.url, tableProps);
    },
    actions(data, type) {
      this[type](data);
    },
    edit(data) {
      this.errors = [];
      this.update = true;
      this.category_id = data.id;
      this.category = {
        title: data.title,
        description: data.description,
        parent_id: data.parent_id,
        service_id: data.service_id,
      };
      this.showCreateModal = true;
    },
    async delete(data) {
      if (await this.$modal.yesNo("آیا از حذف مطمعین هستید؟")) {
        this.$modal.showLoading();
        this.requestApiDelete(`${this.url}/${data.id}`)
          .then(({ data }) => {
            this.$modal.hideLoading();
            this.getMessageCategories();
            this.$toast.success("دسته بندی با موفقیت غیرفعال شد");
          })
          .catch(({ response }) => {
            this.$modal.hideLoading();
          });
      }
    },
  },
  async mounted() {
    try {
      this.services = await this.getService();
    } catch (error) {
      console.error("Failed to fetch services:", error);
      this.$toast.error("خطا در دریافت سرویس‌ها");
    } finally {
    }
    // this.services = this.getService();
    this.getMessageCategories();
    this.getCategoryPatents();
  },
  watch: {
    searchParents(val) {
      this.getCategoryPatents(this.url + "-parent", { search: val });
    },
  },
};
</script>

<style scoped></style>
